import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import OwlCarousel from 'react-owl-carousel2';
import { NEXT_SERVICED_BANNER, PRE_SERVICED_BANNER } from '../../../utils/constants';
import { getBanner, getOfficeInfo } from '../servicedOffice.api';
import { getQueryString } from '../../../utils/params';
import { useParams } from 'react-router-dom';

function BannerOurOfficeComponent() {
  const { language } = useParams();
  const [officeId, setOfficeId] = useState(0);
  const [bannerInfo, setBannerInfo] = useState();

  const options = {
    items: 1,
    margin: 0,
    nav: true,
    navText: [PRE_SERVICED_BANNER, NEXT_SERVICED_BANNER],
    dots: true,
    loop: true,
    autoplay: true,
    autoHeight: true,
    slideTransition: 'linear',
    autoplaySpeed: true,
    autoplayTimeout: 5000,
    responsive: {},
    animateOut: 'fadeOut',
  };

  useEffect(() => {
    getOfficeInfo(getQueryString({ language })).then(res => {
      if (res) {
        setOfficeId(res[0]?.id);
      }
    });

    getBanner(getQueryString({ language, officeId })).then(res => {
      if (res) {
        setBannerInfo(res.images);
      }
    });
    //eslint-disable-next-line
  }, [officeId]);

  function createMarkup(data) {
    if (data) {
      return { __html: data };
    }
  }

  const handleBanner = () => {
    if (bannerInfo) {
      return (
        <OwlCarousel options={options} className="banner nav-top owl-carousel owl-theme owl-loaded owl-drag">
          {bannerInfo
            ? bannerInfo.map((item, index) => {
                return (
                  <div
                    key={index}
                    className="our-office-banner"
                    style={{
                      backgroundImage: `url(${process.env.REACT_APP_ISN_IMAGE_URL}${item.imageUrl})`,
                      backgroundRepeat: 'no-repeat',
                      backgroundPosition: 'center center',
                      backgroundSize: 'cover',
                    }}
                  >
                    <div className="d-flex flex-column align-items-center justify-content-center our-office-banner__info">
                      <div
                        className={`our-office-banner__info--title text-center ${
                          language === 'jp' ? 'font-noto-serif-cjk-jp' : ''
                        }`}
                      >
                        {item.title}
                      </div>
                      <div className="our-office-banner__info--description pt-3 text-center">
                        <div className="col-2"></div>
                        <div className="col-8" dangerouslySetInnerHTML={createMarkup(item.subTitle)}></div>
                        <div className="col-2"></div>
                      </div>
                    </div>
                    <div className="our-office-banner__color-overlay"></div>
                  </div>
                );
              })
            : ''}
        </OwlCarousel>
      );
    }
  };

  return <div id="ourOfficeBanner">{handleBanner()}</div>;
}

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(BannerOurOfficeComponent);
